export default __webpack_public_path__ + "static/media/youtube.12036122.png";